import { apiClient } from "@/api/modules/base";
import { Route } from "@/api/modules/datasheet/documentsDownload/routes.ts";
import type {
    DownloadDocumentsRequest,
    DownloadDocumentsResponse, DownloadLimitResponse, SendDocumentsDownloadLinkRequest, SendDocumentsDownloadLinkResponse
} from "@/api/modules/datasheet/documentsDownload/types.ts";
import { type AxiosPromise } from "axios";

export const createDocumentDownload = (payload: DownloadDocumentsRequest): AxiosPromise<DownloadDocumentsResponse> => apiClient.post(Route.DownloadDocument, payload);

export const sendDocumentsDownloadLink = (payload: SendDocumentsDownloadLinkRequest): AxiosPromise<SendDocumentsDownloadLinkResponse> => apiClient.post(Route.SendDocumentsDownloadLink, payload);

export const getDownloadLimit = (): AxiosPromise<DownloadLimitResponse> => apiClient.get(Route.GetDownloadLimit);
